const style = {
  box: {
    sx: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  title: {
    variant: 'h5',
    sx: {
      pt: 1,
    },
  },
  description: {
    color: 'textSecondary',
    variant: 'body2',
    sx: {
      mt: 2,
    },
  },
} as const;

export default style;
